import { render, staticRenderFns } from "./GeophotoChallengeGallery.vue?vue&type=template&id=46692794&"
import script from "./GeophotoChallengeGallery.vue?vue&type=script&lang=js&"
export * from "./GeophotoChallengeGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports